// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_2LGymnRAuE2GQVpFVve5t7","checked":"Yrc_WYt8RzE1zlZQqXlIY","disabled":"_2f_OA8wSe2HWlQcN_W41Gq","selected":"_3jAKSL5xx_eXRM7os5oGTq","oddsButtonCustom":"_13w4VadXpTh8xGkJyZmSKX"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/football/css/oddsButtonSoccer3.css
// module id = 806
// module chunks = 0